/**
 * Elaastic Image - controls
 *
 * @author Matej Svajger <hello@matejsvajger.com>
 */

import EventEmitter from '../utils/event-emitter'

export default class extends EventEmitter {
  constructor (elements) {
    super()
    for (let element of elements) {
      element.style.cursor = 'pointer'
      element.addEventListener('click', (e) => {
        this.dispatchEvent('click', {
          src: e.target.dataset.src || e.target.src
        })
      })
    }
  }
}
